export var filterBehaviourOptions;
(function (filterBehaviourOptions) {
    filterBehaviourOptions[filterBehaviourOptions["and"] = 1] = "and";
    filterBehaviourOptions[filterBehaviourOptions["or"] = 2] = "or";
})(filterBehaviourOptions || (filterBehaviourOptions = {}));
export var CrmType;
(function (CrmType) {
    CrmType[CrmType["Other"] = 0] = "Other";
    CrmType[CrmType["Prospect"] = 2] = "Prospect";
    CrmType[CrmType["Customer"] = 3] = "Customer";
    CrmType[CrmType["OwnCompany"] = 4] = "OwnCompany";
})(CrmType || (CrmType = {}));
